import angular from 'angular';
import UIRouter from 'angular-ui-router';

import createStub from '../olr-common/createStub';
import './styles/index.scss';
import './addClassPopup.html';
import template from './index.html';
import ClassController from './ClassController';

    
let namespace = angular.module('olr-mainfe-class', [
  UIRouter,
  'olr-common'
]);

namespace.config(function($stateProvider) {
  $stateProvider.state('olr.mainfe.class', {
    url: '/class',
    controller: ClassController,
    controllerAs: 'classCtrl',
    template: template
  });
});

namespace.controller('ClassController', ClassController);

export default namespace.name;





/** WEBPACK FOOTER **
 ** ./src/olr-mainfe-class/index.js
 **/